export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Descrição', field: 'description', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
